/**
 *==================================================
 * Licensed Materials - Property of HCL Technologies
 *
 * HCL Commerce
 *
 * (C) Copyright HCL Technologies Limited 2020
 *
 *==================================================
 * Custom Store for saved banamex session payment
 * @dev EA
 */
//Standard libraries
import { createReducer, AnyAction } from "@reduxjs/toolkit";
//Redux
import * as ACTIONS from "../action-types/inprogressOrders";
import initStates from "./initStates";

/**
 * BanamexSession reducer
 * handles states used by EvoPayments and saved session
 * @param state State object managed by api reducer
 * @param action The dispatched action
 */

const InprogressOrdesrReducer = createReducer(initStates, (builder) => {
  builder.addCase(ACTIONS.SET_INPROGRESS_ORDERS, (state, action: AnyAction) => {
    state.inprogressOrders = action.payload;
  });
  builder.addCase(ACTIONS.CLEAR_INPROGRESS_ORDES, (state, action: AnyAction) => {
    state.inprogressOrders = action.payload;
  });
});

export default InprogressOrdesrReducer;
